import $foreign from "./foreign.cjs";
var mkFn0 = $foreign.mkFn0;
var mkFn10 = $foreign.mkFn10;
var mkFn2 = $foreign.mkFn2;
var mkFn3 = $foreign.mkFn3;
var mkFn4 = $foreign.mkFn4;
var mkFn5 = $foreign.mkFn5;
var mkFn6 = $foreign.mkFn6;
var mkFn7 = $foreign.mkFn7;
var mkFn8 = $foreign.mkFn8;
var mkFn9 = $foreign.mkFn9;
var runFn0 = $foreign.runFn0;
var runFn10 = $foreign.runFn10;
var runFn2 = $foreign.runFn2;
var runFn3 = $foreign.runFn3;
var runFn4 = $foreign.runFn4;
var runFn5 = $foreign.runFn5;
var runFn6 = $foreign.runFn6;
var runFn7 = $foreign.runFn7;
var runFn8 = $foreign.runFn8;
var runFn9 = $foreign.runFn9;
export { mkFn0, mkFn10, mkFn2, mkFn3, mkFn4, mkFn5, mkFn6, mkFn7, mkFn8, mkFn9, runFn0, runFn10, runFn2, runFn3, runFn4, runFn5, runFn6, runFn7, runFn8, runFn9 };
